export default __webpack_public_path__ + "static/media/down.5760a4b3.svg";